import React, {useContext} from 'react';
import { Link } from 'react-router-dom';
import styles from "./Navbar.module.scss";
import { Context } from '../Store';
import { motion } from 'framer-motion';
const ListLinks = () => {
    let{dir,translate,servicesSection,partnersSection,packagesSection,scrollToSection,contactSection} = useContext(Context);
    let{ourServices,ourPartners,packagesAndSubscriptions,help} = translate.navbar;

  return (
    <>
    {dir==="rtl"?<motion.li
                  onClick={()=>scrollToSection(servicesSection)}
                  whileHover={{
                    x: -4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link  to="" className={`${styles.link} ${styles.linkHover}`} >{ourServices[1]}</Link></motion.li>:<motion.li
                  onClick={()=>scrollToSection(servicesSection)}
                  whileHover={{
                    x: 4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="" className={`${styles.link} ${styles.linkHover}`}>{ourServices[0]}</Link></motion.li>}
                   
                    {dir==="rtl"?<motion.li
                    onClick={()=>scrollToSection(partnersSection)}
                    whileHover={{
                    x: -4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="" className={`${styles.link} ${styles.linkHover}`}>{ourPartners[1]}</Link></motion.li>:<motion.li
                    onClick={()=>scrollToSection(partnersSection)}
                whileHover={{
                    x: 4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="" className={`${styles.link} ${styles.linkHover}`}>{ourPartners[0]}</Link></motion.li>}

                    {dir==="rtl"?<motion.li
                    onClick={()=>scrollToSection(packagesSection)}
                whileHover={{
                    x: -4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="" className={`${styles.link} ${styles.linkHover}`}>{packagesAndSubscriptions[1]}</Link></motion.li>:<motion.li
                    onClick={()=>scrollToSection(packagesSection)}
                whileHover={{
                    x: 4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="" className={`${styles.link} ${styles.linkHover}`}>{packagesAndSubscriptions[0]}</Link></motion.li>}
                    
                    {dir==="rtl"?<motion.li
                    onClick={()=>scrollToSection(contactSection)}
                whileHover={{
                    x: -4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="contact-us" className={`${styles.link} ${styles.linkHover}`}>{help[1]}</Link></motion.li>:<motion.li
                    onClick={()=>scrollToSection(contactSection)}
                whileHover={{
                    x: 4,
                    transition: { type: "spring", mass:1, stiffness:1601, damping:60 },}}>
                    <Link to="contact-us" className={`${styles.link} ${styles.linkHover}`}>{help[0]}</Link></motion.li>}
                    
    </>
   
  )
}

export default ListLinks;